export default [{
  path: '/root/:site/',
  name: 'root.home',
  component: () => import('@/views/admin/Index.vue'),
  children: [{
      path: 'exception/job',
      name: 'root.exception.job',
      component: () => import('@/views/root/exception/job/Index.vue')
    },
    {
      path: 'schema/',
      name: 'root.schema',
      component: () => import('@/views/root/schema/Index.vue')
    }
  ]
}]


// WEBPACK FOOTER //
// ./src/router/modules/root.js